import api from "./api";

const getCountryAPI = (data: { language: string[] }) => {
  return api.post("/country/", data, { timeout: 8000 });
};

export default getCountryAPI;
